import { ZfStack, ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { Trans } from 'react-i18next';
import { AVAILABLE_LANGUAGES } from '../../../i18n/i18nextInit';
import type { ITranslation } from '../../../interfaces/generic';
import { MultiLanguageInput } from './MultiLanguageInput';
import { MultiLanguageInputWrapper } from './MultiLanguageInputWrapper';
import { MultiLanguageMarkdownInput } from './MultiLanguageMarkdownInput';

interface IProps {
    label?: string;
    value?: ITranslation;
    multiline?: boolean;
    rows?: number;
    direction?: 'row' | 'column';
    markdown?: boolean;
    collapsible?: boolean;
    expanded?: boolean;
    onChange: (translation: ITranslation) => void;
}

export const MultiLanguageEditor: FunctionComponent<IProps> = ({
    label,
    value,
    multiline,
    direction = 'column',
    markdown,
    rows,
    collapsible = false,
    expanded = false,
    onChange,
}) => (
    <MultiLanguageInputWrapper collapsible={collapsible} expanded={expanded} label={label}>
        {markdown ? (
            <ZfTypography variant="body-medium">
                <Trans
                    i18nKey="contentAdmin.markdownHint"
                    components={{ a: <a target="_blank" rel="noopener noreferrer" href="https://www.markdownguide.org/basic-syntax/" /> }}
                />
            </ZfTypography>
        ) : null}
        <ZfStack direction={direction} spacing="medium">
            {AVAILABLE_LANGUAGES.map((language) =>
                markdown ? (
                    <MultiLanguageMarkdownInput key={language} language={language} value={value} multiline={true} rows={2} onChange={onChange} />
                ) : (
                    <MultiLanguageInput key={language} language={language} value={value} multiline={multiline} rows={rows} onChange={onChange} />
                ),
            )}
        </ZfStack>
    </MultiLanguageInputWrapper>
);
